import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
    button: {
        borderWidth: 3,
        borderColor: "#ffb243",
        borderRadius: 25,
        alignItems: 'center',
        marginLeft: 36,
        width: "25%"
    },
    buttonDefault: {
    },
    buttonHover: {
        backgroundColor: '#ffb243',
        color: '#FCFCFC'
    },
    buttonText: {
        fontSize: 12,
        fontFamily: 'Montserrat',
        fontWeight: '900',
        paddingVertical: 6
    },
    buttonTextDefault: {
        color: '#ffb243'
    },
    buttonTextMobile: {
        color: '#535353',
    },
    buttonTextHover: {
        color: '#FCFCFC',
    },
});